import { LineStepper } from '@linearb/linui-common';
import { useWizard } from 'react-use-wizard';
import { Stack } from '@mui/material';
import { ReactNode, useEffect } from 'react';
import useUserProfile from 'views/root/views/home/hooks/useUserProfile';

const steps = [
  { label: 'addRole' },
  { label: 'addSeniority' },
  { label: 'ChooseInterests' },
  { label: 'ConfigureWorkHours' }
];

/**
 * UserProfileWrapper component provides a wrapper around the wizard steps and renders the stepper.
 */
const UserProfileWrapper = ({
  children
}: {
  children?: ReactNode;
}): JSX.Element => {
  const { activeStep, goToStep } = useWizard();
  const { currentStepIndex } = useUserProfile();

  useEffect(() => {
    goToStep(currentStepIndex);
  }, []);

  return (
    <>
      <Stack sx={{ width: '100%' }} paddingBottom={3} paddingTop={3}>
        <LineStepper steps={steps} activeStep={activeStep} />
      </Stack>
      {children}
    </>
  );
};

export default UserProfileWrapper;
